import { ExpenseGroup, ExpenseEligibilityStatusItem, ExpenseEvidenceUpdateParams, ExpenseEligibility,
  TransactionToRemove, ExpenseDictionary, PossibleExpense } from "@/shared/types";

export const expenseDictionaryItems = (expd: ExpenseDictionary) => Object.keys(expd).map(k =>
  ({ pageNumber: k, items: (<PossibleExpense[]> expd[k]) }));

export const expenseDictionaryPageForTransactionId = (expd: ExpenseDictionary, transactionId: number) =>
  expenseDictionaryItems(expd).find(el => el.items.some(item => item.transactionId === transactionId));

export function updateEligibilityStatus (source: ExpenseGroup, expenseStatusList: ExpenseEligibilityStatusItem[]): any {
  const updatedPages = [];
  Object.keys(source.records).forEach(page => {
    expenseStatusList.forEach(expenseStatus => {
      const expense = source.records[page].find(d => d.transactionId === expenseStatus.transactionId);
      if (expense) {
       expense.eligibilityStatus = expenseStatus.eligibilityStatus;
      }
    });
    updatedPages.push({records: source.records[page], page});
  });
  return updatedPages;
}

export function removeTransaction (source: ExpenseGroup, record: TransactionToRemove): any {
  const updatedPages = [];
  Object.keys(source.records).forEach(page => {
      source.records[page] = source.records[page].filter(d => d.transactionId !== record.transactionId
      || d.eligibilityStatus === ExpenseEligibility.None);
    updatedPages.push({records: source.records[page], page});
  });
  return updatedPages;
}

export function mapFilesToNames (source: ExpenseGroup, attachmentUpdateParams: ExpenseEvidenceUpdateParams) {
  Object.keys(source.records).forEach(page => {
    const possibleExpense = source.records[page].find(d => d.expense && d.expense.id === attachmentUpdateParams.expenseId);
    if (possibleExpense && possibleExpense.expense) {
      if (attachmentUpdateParams.isDelete) {
        possibleExpense.expense.attachmentNames = possibleExpense.expense.attachmentNames.filter(d => {
          return attachmentUpdateParams.expenseEvidenceNames.indexOf(d) === -1;
        });
      } else {
        possibleExpense.expense.attachmentNames.push(...attachmentUpdateParams.expenseEvidenceNames);
      }
    }
  });
}
